import React, { useEffect, useMemo, useState } from 'react';
import {
  Box,
  Fade,
  InputAdornment,
  Paper,
  Popover,
  TextField,
  Typography,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { getFullName } from '@utils';
import styles from './emailReplySignatures.style';

const EmailReplySignatures = ({
  isOpen,
  agent,
  teams = [],
  onClose,
  onChange,
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  useEffect(() => {
    if (!isOpen) {
      setSearchTerm('');
    }
  }, [isOpen]);

  const teamsWithAgent = useMemo(
    () => [
      {
        emailSignature: agent?.emailSignature,
        value: agent?.emailSignature,
        name: getFullName(agent),
      },
      ...teams,
    ],
    [agent, teams]
  );

  const options = useMemo(() => {
    return teamsWithAgent
      ?.filter((team) => team.emailSignature)
      ?.map((team) => ({
        label: team.name,
        value: team.emailSignature,
      }));
  }, [teamsWithAgent]);

  const filteredOptions = useMemo(() => {
    return options.filter((opt) => {
      if (!searchTerm) return true;

      return opt.label?.toLowerCase().includes(searchTerm.toLowerCase());
    });
  }, [searchTerm, options]);

  const getToolbarButton = () => {
    if (document && typeof document !== 'undefined') {
      return document.querySelector('.ql-signatureAction');
    }
  };

  return (
    <Popover
      open={isOpen}
      anchorEl={getToolbarButton()}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
    >
      <Fade in={isOpen}>
        <Paper sx={styles.paper}>
          <Box sx={styles.searchInputWrapper}>
            <TextField
              autoFocus
              size="small"
              placeholder="Search signature..."
              fullWidth
              sx={styles.textField}
              value={searchTerm}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={styles.searchIcon} />
                  </InputAdornment>
                ),
              }}
              onChange={(e) => {
                e.stopPropagation();
                setSearchTerm(e.target.value);
              }}
              onMouseDown={(e) => {
                e.stopPropagation();
              }}
              onClick={(e) => {
                e.stopPropagation();
              }}
              slotProps={{
                htmlInput: {
                  onMouseDown: (e) => {
                    e.stopPropagation();
                  },
                  onFocus: (e) => {
                    e.stopPropagation();
                  },
                },
              }}
            />
          </Box>
          <Box sx={styles.list}>
            {filteredOptions.length === 0 ? (
              <Box sx={styles.noResults}>No results</Box>
            ) : (
              filteredOptions.map((option) => {
                return (
                  <React.Fragment key={option.value}>
                    <Box
                      sx={styles.item}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        onChange(option);
                      }}
                    >
                      <Typography sx={styles.itemLabel}>
                        {option.label}
                      </Typography>
                    </Box>
                  </React.Fragment>
                );
              })
            )}
          </Box>
        </Paper>
      </Fade>
    </Popover>
  );
};

export default EmailReplySignatures;
